export default function validatePassword(password: string) {
  // Regular expression to test the password complexity
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[\S]{8,}$/;
  return passwordRegex.test(password);
}